import { OverlayGrayBackground } from "./OverlayGrayBackground";
import { LoaderSpinner } from "./LoaderSpinner";
import Drawer from "./Drawer";
import { ProductType } from "../consts/productTypes";
import ProductVariantSidebar from "./inventory/ProductVariantSidebar";
import ProductSidebar from "./inventory/ProductSidebar";
import { CreateProductGroupSidebar } from "./inventory/CreateProductGroupSidebar";
import { CreateProductVariantSidebar } from "./inventory/CreateProductVariantSidebar";

export const InventoryProductsSidebar = ({
  selectedProduct,
  access,
  selectedTab,
  onChangeSelectedTab,
  onClose,
  productType,
  currentGroup,
  onSuccessSubmit,
  onClickSidebarVariantView,
  creationVariant,
  isOpen
}) => {
    const updateVendorIsLoading = () => false;
    const loading = false;

    const title = 
        selectedProduct ? selectedProduct?.name : 
        creationVariant === 'group' ? "Create Product" : 
        creationVariant === 'variant' ? "Create Product Variant" : 
        "";

    const formId = 
        creationVariant === "group" ? "create-group-form" :
        creationVariant === "variant" ? "create-variant-form" :
        "";

    return (
        <Drawer 
            isOpen={isOpen} 
            onClose={onClose} 
            title={title} 
            variant={'inventory-products'} 
            size="lg" 
            showActionButtons={creationVariant ? true : false}
            submitButtonText={creationVariant ? "Create" : ""}
            formId={formId}
        >
            <div className="p-6">
                {updateVendorIsLoading() && <OverlayGrayBackground />}
                {loading ? (
                    <div className="z-10 flex h-full items-center justify-center">
                        <LoaderSpinner width='70' height='70' border='3' colorSpinner='black' />
                    </div>
                ) : (
                    (selectedProduct && productType === ProductType.PRODUCT_VARIANT) ? (
                        <ProductVariantSidebar 
                            key={selectedProduct?.id}
                            access={access}
                            selectedTab={selectedTab?.variant}
                            onChangeSelectedTab={onChangeSelectedTab}
                            product={selectedProduct} 
                            onClose={onClose} 
                        />
                    ) : (selectedProduct && productType === ProductType.PRODUCT) ? (
                        <ProductSidebar 
                            key={selectedProduct?.id}
                            access={access}
                            selectedTab={selectedTab?.group}
                            onChangeSelectedTab={onChangeSelectedTab}
                            product={selectedProduct} 
                            onClose={onClose} 
                            onClickSidebarVariantView={onClickSidebarVariantView} 
                        />
                    ) : creationVariant === "group" ? (
                        <CreateProductGroupSidebar
                            formId={formId}
                            access={access}
                            onSuccessSubmit={onSuccessSubmit}
                        />
                    ) : creationVariant === "variant" ? (
                        <CreateProductVariantSidebar
                            formId={formId}
                            access={access}
                            currentGroup={currentGroup}
                            onSuccessSubmit={onSuccessSubmit}
                        />
                    ) : null
                )}
            </div>
        </Drawer>
    );
};